<template>
    <v-container fluid>
      <div id="app ">
        <div style="display:flex; justify-content: flex-end;">
          <!-- <v-col cols="11"> -->
          <Breadcrumb class="row justify-content-center mt-4" />
          <!-- </v-col> -->
          <span cols="1" v-if="showLoader">
            <LoaderProgress></LoaderProgress>
          </span>
        </div>
      </div>
      <div
        style="display: flex; justify-content:space-evenly; flex-wrap: wrap; background-color: white;"
      >
        <!-- Dropdown to select drilldown -->
        <v-col style="padding: 0 15px;">
          <v-autocomplete
            v-model="selectedDrilldown"
            :items="drilldownOptions"
            label="Select Drilldown"
            item-text="drilldown_name"
            item-value="drilldown_id"
          ></v-autocomplete>
        </v-col>
  
        <v-col style="display: flex; justify-content: center;">
          <v-dialog v-model="dialog" max-width="400px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-2 ml-4"
                small
                fab
                @click="addDoc()"
                color="#0C479D"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon class="icon-white">icon-add</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="background-blue " style="color: white;"
                >Add new Drilldown</v-card-title
              >
              <v-card-text class="mt-5">
                <v-text-field
                  v-model="newDrilldownName"
                  label="Enter drilldown name*"
                  required
                ></v-text-field>
                <v-autocomplete
                  v-model="addedPages"
                  :items="pageOptions"
                  label="Select pages"
                  item-text="page_name"
                  item-value="page_id"
                  multiple
                  @change="getLandingPages"
                  chips
                ></v-autocomplete>
                <v-autocomplete
                  v-model="selectedLanding"
                  label="Select Landing Page"
                  item-text="page_name"
                  item-value="page_id"
                  :items="landingPages"
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-actions class="pb-5">
                <v-spacer></v-spacer>
                <v-btn rounded color="#FE000C" @click="close">
                  <v-icon left class="icon-white">icon-cancel</v-icon>
                  <span style="color: white;">Cancel</span>
                </v-btn>
  
                <v-btn
                  color="primary"
                  @click="submitForm"
                  :disabled="newDrilldownName.length === 0"
                  rounded
                >
                  <v-icon left>icon-availability</v-icon>
                  Submit
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
  
        <v-col>
          <!-- Save Button -->
          <v-btn
            @click="saveChanges"
            :disabled="!isSaveButtonEnabled"
            class="mr-2 ml-4"
            color="primary"
          >
            <v-icon>mdi-content-save</v-icon>
            Save Changes
          </v-btn>
        </v-col>
      </div>
  
      <!-- Table to display pages for the selected drilldown -->
      <v-data-table
        :headers="tableHeaders"
        :items="getPageOptionsForDrilldown(selectedDrilldown)"
        :items-per-page="5"
        class="elevation-1"
        :mobile-breakpoint="0"
        :search="search"
      >
        <template v-slot:top>
          <div
            style="display: flex; justify-content: space-around; flex-wrap: wrap;"
          >
            <v-col style="margin:0 5%">
              <v-autocomplete
                v-model="updatedLandingPage"
                label="Landing Page"
                :items="enabledPagesList"
                @change="toggleChange"
                item-value="drilldownPage_id"
                item-text="page_name"
              ></v-autocomplete>
            </v-col>
            <v-col style="margin: 0 5%">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </div>
        </template>
        <template v-slot:item.toggle="{ item }">
          <!-- Toggle switch column -->
          <v-switch v-model="item.toggle" @change="toggleChange(item)"></v-switch>
        </template>
        <!-- <template v-slot:item.landing="{ item }">
          <v-switch
            v-if="item.toggle"
            v-model="item.landing"
            @change="toggleChange(item)"
          ></v-switch>
        </template> -->
      </v-data-table>
    </v-container>
  </template>
  
  <script>
  import axios from "axios";
  import router from "../router";
  import LoaderProgress from "../components/progressLoader";
  import Breadcrumb from "../components/breadcrumbs.vue";
  
  export default {
    components: {
      LoaderProgress,
      Breadcrumb,
    },
    data() {
      return {
        dialog: false,
        selectedDrilldown: "",
        drilldownOptions: [],
        tableHeaders: [
          { text: "Page Name", value: "page_name" },
          { text: "Toggle", value: "toggle" },
        ],
        newDrilldownName: "",
        allPages: [],
        drilldownPagesMapping: [],
        isSaveButtonEnabled: false,
        enableSubmit: false,
        selectedDrilldownData: null,
        toggleChanges: [],
        addedPages: [],
        pageOptions: [],
        search: "",
        updatedLandingPage: null,
        selectedLanding: null,
        landingPages: [],
        enablePages: [],
        disablePages: [],
      };
    },
  
    watch: {
      selectedDrilldown(newValue, oldValue) {
        // Watch for changes in selectedDrilldown and update updatedLandingPage
        this.setInitialLandingPage();
        console.log(newValue, oldValue);
      },
    },
  
    created() {
      this.getAllPages();
      this.fetchdrilldownPages();
    },
  
    computed: {
      enabledPagesList() {
        // Compute and return the enabled pages list for the selected drilldown
        const selectedDrilldownData = this.drilldownPagesMapping.find(
          (drilldown) => drilldown.drilldown_id == this.selectedDrilldown
        );
  
        console.log("selectedDrilldownData:", selectedDrilldownData);
  
        const enabledPages = selectedDrilldownData
          ? selectedDrilldownData.pages
              .filter((page) => page.page_status === true)
              .map((page) => page)
          : [];
  
        console.log("Enabled Pages:", enabledPages);
        return enabledPages;
      },
    },
  
    methods: {
      setInitialLandingPage() {
        const selectedDrilldownData = this.drilldownPagesMapping.find(
          (drilldown) => drilldown.drilldown_id == this.selectedDrilldown
        );
  
        if (selectedDrilldownData) {
          const landingPage = selectedDrilldownData.pages.find(
            (page) => page.landing === true
          );
          console.log("initialLandingPage:", landingPage);
  
          if (landingPage) {
            this.updatedLandingPage = landingPage.drilldownPage_id;
            console.log("wwwwww", this.updatedLandingPage);
          } else {
            this.updatedLandingPage = null;
          }
        }
      },
  
      getAddLandingPages() {
        this.landingPages = this.allPages.filter((page) =>
          this.addedPages.includes(page.page_id)
        );
  
        console.log("landingPages:", this.landingPages);
      },
  
      getLandingPages() {
        console.log("added Pages:", this.addedPages);
        this.getAddLandingPages();
        this.isSaveButtonEnabled = true;
      },
  
      getAllPages() {
        this.showLoader = true;
        let config = {
          method: "get",
          url: `${this.$config.backend_url}/getallPages`,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        };
  
        this.noteLastAPICallTime();
  
        axios(config)
          .then((response) => {
            console.log("srinadhhhhhh", response.data);
            this.allPages = response.data.data;
            this.pageOptions = this.allPages;
            this.showLoader = false;
          })
          .catch((error) => {
            if (error.response && error.response.status === 401) {
              sessionStorage.clear();
              router.push("/login");
            } else {
              console.error("Error fetching all pages:", error.message);
              this.showLoader = false;
            }
          });
      },
  
      fetchdrilldownPages() {
        this.showLoader = true;
  
        let config = {
          method: "get",
          url: `${this.$config.backend_url}/getdrilldownPages`,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        };
  
        this.noteLastAPICallTime();
  
        axios(config)
          .then((response) => {
            console.log("mmkkkkkkkkkkkkkkkk", response.data.data);
            this.drilldownPagesMapping = response.data.data;
            this.drilldownOptions = this.drilldownPagesMapping;
            this.showLoader = false;
  
            console.log("jjjjjjjjjjjjjjjj", this.drilldownOptions);
          })
          .catch((error) => {
            this.showLoader = false;
            if (error.response && error.response.status === 401) {
              sessionStorage.clear();
              router.push("/login");
            } else {
              alert("internal error");
              console.log("axios error", error.message);
            }
          });
      },
  
      getPageOptionsForDrilldown(selectedDrilldown) {
        // Find the selected drilldown data
        const selectedDrilldownData = this.drilldownPagesMapping.find(
          (drilldown) => drilldown.drilldown_id == selectedDrilldown
        );
  
        const allPagesWithStatus = this.allPages.map((page) => {
          const matchingPage = selectedDrilldownData
            ? selectedDrilldownData.pages.find(
                (drilldownPage) => drilldownPage.page_id === page.page_id
              )
            : null;
  
          return {
            drilldown_name: selectedDrilldownData
              ? selectedDrilldownData.drilldown_name
              : null,
            page_id: page.page_id,
            page_name: page.page_name,
            toggle: matchingPage ? matchingPage.page_status : false,
            drilldownPage_id: matchingPage ? matchingPage.drilldownPage_id : null,
          };
        });
  
        return allPagesWithStatus;
      },
  
      close() {
        this.dialog = false;
        this.newDrilldownName = "";
        this.addedPages = [];
        this.selectedLanding = null;
      },
  
      addDoc() {
        this.dialog = true;
      },
      submitForm() {
        if (this.newDrilldownName.trim() !== "") {
          const newDrilldownData = {
            drilldown_name: this.newDrilldownName,
            selctedPages_id: this.addedPages,
            landingPage_id: this.selectedLanding,
          };
          this.showLoader = true;
          let config = {
            method: "post",
            url: `${this.$config.backend_url}/saveDrilldown`,
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
            data: newDrilldownData,
          };
          this.noteLastAPICallTime();
          axios(config)
            .then((response) => {
              this.showLoader = false;
              console.log('response.data',response.data)
              if (response.data.status == "S") {
                this.fetchdrilldownPages();
                this.$toast.success("New Drilldown Created", {
                  position: "top-right",
                  timeout: 5000,
                });
              }
            })
            .catch((error) => {
              this.showLoader = false;
              if (error.response && error.response.status === 401) {
                sessionStorage.clear();
                router.push("/login");
              } else {
                document.querySelector("#errorAlert").style.display = "block";
                console.log("axios error", error.message);
              }
            });
          //this.drilldownOptions.push(this.newDrilldownName);
        }
        console.log();
  
        this.dialog = false;
        this.newDrilldownName = "";
        this.addedPages = [];
        this.selectedLanding = null;
      },
  
      toggleChange(item) {
        this.isSaveButtonEnabled = true;
        console.log("vvvvvvvvv", item.landing, this.updatedLandingPage);
        // Check if there's an existing change for the current page
        const existingChange = this.toggleChanges.find(
          (change) => change.page_id === item.page_id
        );
  
        // If there's an existing change, update it; otherwise, add a new change
        if (existingChange) {
          existingChange.toggle = item.toggle;
        } else {
          console.log("aaaaaaaaa", this.updatedLandingPage, item);
          if (item.toggle === true) {
            this.enablePages.push(item.page_id);
          } else if (item.toggle === false) {
            this.disablePages.push(item.drilldownPage_id || item.page_id);
          }
  
          const enableIndex = this.enablePages.indexOf(item.page_id);
          const disableIndex = this.disablePages.indexOf(item.page_id);
  
          if (item.toggle === true) {
            if (enableIndex !== -1) {
              this.disablePages.splice(disableIndex, 1);
            }
          } else {
            if (disableIndex !== -1) {
              this.enablePages.splice(enableIndex, 1);
            }
          }
        }
      },
  
      saveChanges() {
        this.showLoader = true;
  
        const selectedDrilldownData = this.drilldownPagesMapping.find(
          (drilldown) => drilldown.drilldown_id == this.selectedDrilldown
        );
  
        if (selectedDrilldownData) {
          const updatePageStatus = {
            drilldown_id: selectedDrilldownData.drilldown_id,
            enablepages: this.enablePages,
            disablePages: this.disablePages,
            updatedLandingPage: this.updatedLandingPage,
          };
  
          console.log("updatePageStatus:", this.updatedLandingPage);
  
          let config = {
            method: "post",
            url: `${this.$config.backend_url}/updatepagestatus`,
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
            data: updatePageStatus,
          };
  
          this.noteLastAPICallTime();
          axios(config)
            .then((response) => {
              if (response.data.data == "S") {
                console.log(response.data);
                this.fetchdrilldownPages();
                this.getAllPages();
                this.showLoader = false;
  
                this.$toast.success("successfully Updated", {
                  position: "top-right",
                  timeout: 3000,
                });
              } else {
                this.$toast.error(response.data.data, {
                  position: "top-right",
                  timeout: 5000,
                });
                this.fetchdrilldownPages();
                this.getAllPages();
                this.showLoader = false;
              }
            })
            .catch((error) => {
              this.$toast.error(error, {
                position: "top-right",
                timeout: 5000,
              });
              console.error("Error:", error);
            });
  
          this.isSaveButtonEnabled = false;
          this.toggleChanges = []; // Reset the toggle changes after saving
          this.selectedDrilldownData = selectedDrilldownData; // Update selectedDrilldownData
          this.enablePages = [];
          this.disablePages = [];
        } else {
          console.error(
            "Selected drilldown data is undefined or missing 'drilldown_id' property."
          );
        }
      },
    },
  };
  </script>
  
  <style scoped></style>